
import React, { lazy, useEffect, useRef, useState } from "react";
import SectionSkeleton from "./sectionskeleton";
import LazySection from "components/lazySection";
const Newlist = lazy(() => import('components/media/new/newlist'));

const NewBanner = lazy(() => import('components/media/new/newBanner'));
const News: React.FC = () => {

  return (
    <>
      <NewBanner />
        <LazySection fallback={<SectionSkeleton height={300} />}>
        <Newlist />
      </LazySection> 
    </>
  );
};

export default News;
